/**
 * @file sonner.tsx
 * @description Toast-провайдер на sonner (phase08.5). Кастомизирован под
 * Chaiberi Editorial — кремовый фон + оливковый акцент.
 */

import { Toaster as SonnerToaster } from "sonner";
import * as React from "react";

export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return (
    <SonnerToaster
      position="top-right"
      theme="light"
      // Тост — верх шкалы слоёв (`--z-*` в `index.css`): он обязан читаться
      // поверх диалога и шторки. Свой `z-index: 999999999` у sonner
      // перебиваем, чтобы перекрытия админки жили в одном реестре.
      style={{ zIndex: "var(--z-toast)" }}
      toastOptions={{
        classNames: {
          toast:
            "group rounded-xl bg-surface-lowest text-on-surface shadow-[0_8px_24px_var(--shadow-ambient)] ring-1 ring-outline-variant px-4 py-3",
          title: "font-medium text-on-surface",
          description: "text-on-surface-variant text-sm",
          // Кнопка в тосте — цель касания 48 до 1024 («Вернуть как было», QA Р3а D1);
          // min-height перебивает фиксированную высоту 24 из стилей sonner.
          actionButton:
            "inline-flex min-h-12 items-center rounded-md bg-primary text-on-primary px-3 text-sm font-medium lg:min-h-8 lg:text-xs",
          cancelButton:
            "inline-flex min-h-12 items-center rounded-md bg-surface-low text-on-surface px-3 text-sm font-medium lg:min-h-8 lg:text-xs",
          success: "[&_[data-icon]]:text-success",
          error: "[&_[data-icon]]:text-destructive",
          warning: "[&_[data-icon]]:text-warning",
          info: "[&_[data-icon]]:text-info",
        },
      }}
      {...props}
    />
  );
}
